import { createSelector } from 'reselect';

import { housing } from './housingReducer';

export function valueReducer(state, action) {
	if (action.type === 'value/setValue') {
		return {
			...state,
			valueReducer: {
				...state.valueReducer,
				[action.name]: action.value,
			},
		};
	}
	return state;
}

export const initialValueReducer = {
	valueReducer: {
		WOZSocialPerM2: 0,
		WOZFreeSectorPerM2: 0,
		WOZBuyPerM2: 0,

		VONSocialPerM2: 0,
		VONFreeSectorPerM2: 0,
		VONBuyPerM2: 0,

		// rebuildValueSocialPerM2: 2900,
		// rebuildValueFreeSectorPerM2: 3300,
		// rebuildValueBuyPerM2: 3500,

		inflationSocialPerYear: 0,
		inflationFreeSectorPerYear: 2,
		inflationBuyPerYear: 0,
	},
};

export const value = (state) => state.valueReducer;
export const totalWOZSocial = createSelector(
	housing,
	value,
	(housing, value) => housing.noHouses.social * housing.areaVvo.social * value.WOZSocialPerM2
);

export const totalWOZFreeSector = createSelector(
	housing,
	value,
	(housing, value) => housing.noHouses.freeSector * housing.areaVvo.freeSector * value.WOZFreeSectorPerM2
);

export const totalWOZBuy = createSelector(
	housing,
	value,
	(housing, value) => housing.noHouses.buy * housing.areaVvo.buy * value.WOZBuyPerM2
);
